import React, { memo } from "react";
import { Image } from "react-native";
import { useScreenDimensions } from "../_layout";
import { observer } from "mobx-react";

const LogoImage = observer(({ coach, maxWidth = null }) => {
  const { screenSize } = useScreenDimensions();
  const adjustedHeight = screenSize === "small" ? 30 : 50;
  const aspectRatioHW =
    typeof coach?.logoAspectRatioHW === "number" && coach.logoAspectRatioHW > 0
      ? coach.logoAspectRatioHW
      : 1;
  const adjustedWidth = adjustedHeight / aspectRatioHW;
  const needsWidthCap =
    typeof maxWidth === "number" && maxWidth > 0 && adjustedWidth > maxWidth;
  const renderedWidth = needsWidthCap ? maxWidth : adjustedWidth;
  const renderedHeight = needsWidthCap
    ? adjustedHeight * (maxWidth / adjustedWidth)
    : adjustedHeight;

  // console.log("LogoImage Refreshed");
  // Render the image only if coach.logoUrl exists
  return (
    coach.logoUrl && (
      <Image
        source={{ uri: coach.logoUrl }}
        style={{
          width: renderedWidth,
          height: renderedHeight,
          borderRadius: 8,
        }}
        //  testID="maskedLogo"
        // nativeID="maskedLogo"
        // dataSet={{ sensitive: "true" }}
      />
    )
  );
});

// Use React.memo to prevent unnecessary re-renders when props don't change
export default memo(LogoImage);
